// 节流函数，限制函数执行频率
export const throttle = (func, limit) => {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};
  
// 专题横幅
export const initActivityBannerHandler = () => {
  // 关闭专题横幅
  $('.activity-btn-close').on('click', () => {
    // 隐藏专题横幅
    $('.activity-banner-section').addClass('activity-banner-hidden');
    // 恢复导航位置
    $('.header').addClass('header-normal');
    // 恢复价格页面版本顶部位置
    $('.version-header').addClass('version-header-normal'); 
  })
}

// 初始化链接参数
// export const initUrlParamsHandler = () => {
//   const params = {};
//   const urlParams = new URLSearchParams(window.location.search);
//   for (const [key, value] of urlParams.entries()) {
//     params[key] = value;
//   }
//   localStorage.setItem("params", JSON.stringify(params));
// }


// 解析URL参数并返回参数对象
export const getUrlParams = () => {
  const params = {};
  const url = window.location.href;
  const index = url.indexOf('?');
  
  if (index !== -1) {
    const queryString = url.substring(index + 1);
    const paramPairs = queryString.split('&');
    
    paramPairs.forEach(pair => {
      const [key, value] = pair.split('=');
      if (key && value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });
  }
  return params;
    
}

// 保存参数到本地存储
export const saveParamsToStorage = (params) => {
  if (Object.keys(params).length > 0) {
    localStorage.setItem('params', JSON.stringify(params));
  }
}

// 从本地存储获取参数
export const getParamsFromStorage = () => {
  const paramsStr = localStorage.getItem('params');
  return paramsStr ? JSON.parse(paramsStr) : {};
}

// 合并URL参数和存储中的参数（URL参数优先级更高）
export const mergeParams = () => {
  const urlParams = getUrlParams();
  const storedParams = getParamsFromStorage();
  
  // 使用ES6对象扩展运算符合并，URL参数覆盖存储参数
  const mergedParams = { ...storedParams, ...urlParams };
  
  // 如果有新参数，更新存储
  if (JSON.stringify(mergedParams) !== JSON.stringify(storedParams)) {
    saveParamsToStorage(mergedParams);
  }
  
  return mergedParams;
}

// 从指定URL解析参数
export const getUrlParamsFromUrl = (url) => {
  const params = {};
  const index = url.indexOf('?');
  
  if (index !== -1) {
    const queryString = url.substring(index + 1);
    const paramPairs = queryString.split('&');
    
    paramPairs.forEach(pair => {
      const [key, value] = pair.split('=');
      if (key && value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });
  }
  
  return params;
}

// 为链接添加参数
export const addParamsToLinksHandler = (params) => {

  if (Object.keys(params).length === 0) return;
  
  // 处理所有a标签
  $('.nav a').each(function() {
    const $this = $(this);
    let href = $this.attr('href');
    
    // 只处理站内链接，排除锚点和空链接
    if (href && href !== '#' && !href.startsWith('http://') && !href.startsWith('https://')) {
      const separator = href.indexOf('?') !== -1 ? '&' : '?';
      const paramString = $.param(params);
      
      // 检查是否已经包含相同参数，避免重复添加
      const existingParams = getUrlParamsFromUrl(href);
      let needsUpdate = false;
      
      Object.entries(params).forEach(([key, value]) => {
        if (existingParams[key] !== value) {
          needsUpdate = true;
        }
      });
      
      if (needsUpdate) {
        $this.attr('href', `${href}${separator}${paramString}`);
      }
    }
  });
}

// 页面跳转
export const pageJumpHandler = () => {
  $(".pageJump").on('click', function(e) {
    // 阻止默认的点击行为
    e.preventDefault();
    // 获取链接参数，增加空值检查
    const paramsStr = localStorage.getItem('params');
    // 确保params是一个对象，避免null或undefined
    const params = paramsStr ? JSON.parse(paramsStr) : {};
    // 获取链接的href属性
    const url = $(this).attr('href');
    // 只有当params存在且有属性时才构建查询字符串
    const queryString = Object.keys(params).length 
      ? Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&')
      : '';
    location.href = queryString ? `${url}?${queryString}` : url;
  })
}

// 导航按钮页面跳转(新窗口打开)
export const pageJumpBlankHandler = () => {
  $(".pageJumpBlank").on('click', function(e) {
    // 阻止默认的点击行为
    e.preventDefault();
    // 获取链接参数
    const params = JSON.parse(localStorage.getItem('params'));
    // 获取链接的href属性
    const url = $(this).attr('href');
    const queryString = params ? Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&') : '';
    window.open(queryString ? `${url}?${queryString}` : url, '_blank')
  })
}
  
// 滚动处理
export const initScrollHandler = () => {
  $(window).on('scroll', throttle(function() {
    const scrollPosition = $(window).scrollTop();

    // 导航栏样式变化
    const pageHeader = $(".header");
    if (scrollPosition > 110) {
      pageHeader.addClass("header-scroll-handler");
    } else {
      pageHeader.removeClass("header-scroll-handler");
    }

    // 返回顶部按钮显示/隐藏
    const backToTopButton = $('#backToTop');
    if ($(window).scrollTop() > 150) {          
      backToTopButton.addClass("visible");
    } else {
      backToTopButton.removeClass("visible");
    }
  }, 20));

  // 返回顶部按钮点击事件
  $('#backToTop').on( 'click', () => {
    $('html, body').animate({
      scrollTop: 0
    }, 100);
  });
};
  
// 导航栏初始化
export const initNavBarHandler = () => {
  // 产品下拉
  $('.nav-product').on('mouseover', () => {
    $(".header").addClass("header-product-active");
  });

  $('.nav-product').on('mouseout', () => {
    $(".header").removeClass("header-product-active");
  });

  // 解决方案处理
  $('.nav-solutions').on('mouseover', () => {
    $(".header").addClass("header-solutions-active");
  });

  $('.nav-solutions').on('mouseout', () => {
    $(".header").removeClass("header-solutions-active");
  });

  // 帮助下拉处理
  $('.nav-help').on('mouseover', () => {
    $(".header").addClass("header-help-active");
  });

  $('.nav-help').on('mouseout', () => {
    $(".header").removeClass("header-help-active");
  });

  // 关于下拉处理
  $('.nav-about').on('mouseover', () => {
    $(".header").addClass("header-about-active");
  });

  $('.nav-about').on('mouseout', () => {
    $(".header").removeClass("header-about-active");
  });
};
  
// 解决方案Tab切换
export const navSolutionsTabHandler = () => {
  // 获取Tab组件元素
  const $tabNavItems = $('.solutions-tab-item');
  const $tabPanes = $('.solutions-tab-pane');

  $tabNavItems.on( 'click', (e) => {
    const $this = $(e.currentTarget);
    const tabId = $this.attr('data-tab');
    
    // 移除所有活动状态
    $tabNavItems.removeClass('active');
    $tabPanes.removeClass('active');
    // 添加当前活动状态
    $this.addClass('active');
    $(`#${tabId}`).addClass('active');
  });
};